<template>
  <router-view />
</template>

<script>
export default {
  name: "AnomalyDetectionIndex",
};
</script>
